export default {"gitHash":"ff1ddd7dfe864259b39754f6d0e2967f151963fe","gitHashShort":"ff1ddd7","time":1675783154564,"platform":"linux","arch":"x64"};